import i18n from '@/utils/i18n';

const usersFilters =
    [
        {
            "name": "promoActivations.completed_signups",
            "label": i18n.t('form.show_only_completed_signups'),
            "type": "checkbox",
            "main": false,
            value: 'succeeded'
        }
    ];

export default usersFilters
